import { Box, Text, Spinner, Center, Select } from "@chakra-ui/react";
import { AlertsContext } from "providers/alerts";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useCallback, useContext, useEffect, useState } from "react";
import { getErrorMessage } from "utils/errorHandler";
import { permissionConstants, hasPermission } from "utils/permissionHelper";
import { checkUiConfiguration } from "utils/uiconfighelper";
import { useLoanActions } from "providers/loans/mutations/loan-actions";

const LoanStatus = () => {
  const { user } = useTenant();

  const { loan } = useContext(LoanContext);
  const { showSuccess, showError } = useContext(AlertsContext);
  const [statuses, setStatuses] = useState<{ id: string; label: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);

  const { applyChanges } = useLoanActions();

  const isLoanSectionEnabled = useCallback(() => {
    return checkUiConfiguration(user, "loan_section");
  }, [user]);

  useEffect(() => {
    if (
      hasPermission(user, permissionConstants.readOnlyLoans) &&
      !hasPermission(user, permissionConstants.approveLoan)
    ) {
      setReadOnly(true);
    } else {
      if (user.type === "borrower" && loan?.status?.isSubmitted) {
        setReadOnly(true);
      }
    }

    let lenderCompanyStatuses = user.lender_company?.statuses ?? user.company.statuses;

    if (isLoanSectionEnabled()) {
      lenderCompanyStatuses = lenderCompanyStatuses.filter(
        (a: any) => a.isSubmitted === loan?.status?.isSubmitted
      );
    }

    const filteredStatuses = lenderCompanyStatuses.sort((a: any, b: any) => a.order - b.order);

    setStatuses(filteredStatuses);
  }, [isLoanSectionEnabled, loan, user]);

  async function updateStatus(ev: any) {
    try {
      setLoading(true);

      await applyChanges.mutateAsync({
        id: loan!.id,
        status: parseInt(ev.target.value),
      });

      showSuccess({
        title: "Status Updated",
        description: "The loan status has been successfully updated.",
      });
    } catch (err) {
      showError({
        title: "Update Failed",
        description: getErrorMessage(err),
      });
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return (
    <Box>
      <Text fontSize="13px" lineHeight="24px">
        {loan?.status?.description}
      </Text>
      {!readOnly && user.type === "lender" && (
        <Select onChange={updateStatus} value={loan?.status?.id} mt="18px">
          {statuses.map((s: any) => (
            <option key={s.id} value={s.id}>
              {s.label}
            </option>
          ))}
        </Select>
      )}
    </Box>
  );
};

export default LoanStatus;
